// icons/index.ts
// List of available icons
export const iconComponents = {
    accountSettings: () => import('./AccountSettings.vue'),
    add: () => import('./Add.vue'),
    addScan: () => import('./AddScan.vue'),
    alarmBell: () => import('./AlarmBell.vue'),
    alert: () => import('./Alert.vue'),
    api: () => import('./Api.vue'),
    apple: () => import('./Apple.vue'),
    archive: () => import('./Archive.vue'),
    arrowRight: () => import('./ArrowRight.vue'),
    arrowUp: () => import('./ArrowUp.vue'),
    battery: () => import('./Battery.vue'),
    bin: () => import('./Bin.vue'),
    boat: () => import('./Boat.vue'),
    calendar: () => import('./Calendar.vue'),
    celsius: () => import('./Celsius.vue'),
    check: () => import('./Check.vue'),
    checkCircle: () => import('./CheckCircle.vue'),
    chevronLeft: () => import('./ChevronLeft.vue'),
    chevronRight: () => import('./ChevronRight.vue'),
    close: () => import('./Close.vue'),
    connections: () => import('./Connections.vue'),
    copy: () => import('./Copy.vue'),
    dashboard: () => import('./Dashboard.vue'),
    download: () => import('./Download.vue'),
    drag: () => import('./Drag.vue'),
    drop: () => import('./Drop.vue'),
    edit: () => import('./Edit.vue'),
    editUser: () => import('./EditUser.vue'),
    envelope: () => import('./Envelope.vue'),
    fahrenheit: () => import('./Fahrenheit.vue'),
    field: () => import('./Field.vue'),
    flag: () => import('./Flag.vue'),
    google: () => import('./Google.vue'),
    humidity: () => import('./Drop.vue'),
    hyperlink: () => import('./Hyperlink.vue'),
    infoMark: () => import('./InfoMark.vue'),
    information: () => import('./Information.vue'),
    label: () => import('./Label.vue'),
    layers: () => import('./Layers.vue'),
    locationPointer: () => import('./LocationPointer.vue'),
    move: () => import('./Move.vue'),
    moveLeft: () => import('./MoveLeft.vue'),
    moveRight: () => import('./MoveRight.vue'),
    navigationsDots: () => import('./NavigationsDots.vue'),
    package: () => import('./Package.vue'),
    plane: () => import('./Plane.vue'),
    questionCircle: () => import('./QuestionCircle.vue'),
    questionMark: () => import('./QuestionMark.vue'),
    reset: () => import('./Reset.vue'),
    search: () => import('./Search.vue'),
    settings: () => import('./Settings.vue'),
    share: () => import('./Share.vue'),
    shock: () => import('./Vibration.vue'),
    signal: () => import('./Signal.vue'),
    signOut: () => import('./SignOut.vue'),
    start: () => import('./Start.vue'),
    temperature: () => import('./Temperature.vue'),
    temperatureHumidity: () => import('./TemperatureHumidity.vue'),
    temperatureMax: () => import('./TemperatureMax.vue'),
    temperatureMin: () => import('./TemperatureMin.vue'),
    templates: () => import('./Templates.vue'),
    train: () => import('./Train.vue'),
    triangleDown: () => import('./TriangleDown.vue'),
    triangleUp: () => import('./TriangleUp.vue'),
    truck: () => import('./Truck.vue'),
    upload: () => import('./Upload.vue'),
    user: () => import('./User.vue'),
    users: () => import('./Users.vue'),
    vibration: () => import('./Vibration.vue')
};
// Export types
export const iconList = Object.keys(iconComponents);
